import nfetch from "../utils/events/nfetch";

export default class CorreiosService {
    public gerarEtiqueta(vendaIds: number[], servicoId: number): Promise<Response> {
        return nfetch(`/Correios/GerarEtiqueta?servicoId=${servicoId}`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify(vendaIds),
        });
    }

    public getCotacaoFrete(obj: object): Promise<Response> {
        return nfetch(`/Correios/GetCotacaoFrete`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify(obj),
        });
    }
}
